<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Manage Collection Point</div>
        <div>
          <bread-crumb :bread-crumbs="['Manage Collection Point']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
  <v-card-text>
      <v-row class="ms-1 me-1 mt-1">
        <v-col cols="12" md="2" lg="2" xs="12">
          <!-- <label class="required labelFontsize   my-0"> Country </label> -->
          <v-autocomplete
            class=""
            dense
            outlined
            placeholder="Country"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="2" lg="2" xs="12">
          <!-- <label class="required labelFontsize   my-0"> Delivery Mode</label> -->
          <v-autocomplete
            class=""
            dense
            outlined
            placeholder="Delivery Mode"
          ></v-autocomplete>
        </v-col>
        <!-- <v-col cols="12" md="2" lg="2" xs="12">
          <label class="required labelFontsize   my-0">
            Payout Partner
          </label>
          <v-autocomplete
            class="rounded"
            dense
            outlined
            placeholder="Select Payout Partner"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="2" lg="2" xs="12">
          <label class="required labelFontsize   my-0"> Payment Type</label>
          <v-autocomplete
            class="rounded"
            dense
            outlined
            placeholder="Select Payment Type"
          ></v-autocomplete>
        </v-col> -->
        <div class="d-flex">
          <v-btn depressed  class=" text-capitalize" small color="primary"
            >View</v-btn
          ><v-btn depressed  class=" ms-3 text-capitalize" small color="primary" outlined
            >New</v-btn
          >
        </div>
      </v-row>
      <v-row class="mb-5">
        <v-col cols="12" md="4" lg="4" xs="12">
          <v-btn depressed  @click="downloadExcelsheet"  color="primary" small
          ><v-icon small>mdi-file-excel-outline</v-icon>Export
        </v-btn>
        </v-col>
        <v-col cols="12" md="3" lg="5" xs="12"></v-col>
        <v-col cols="12" md="4" lg="3" xs="12"
          ><v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Type here to search the table data."
            hide-details
            class="me-4"
            dense
            clearable
          ></v-text-field
        ></v-col>
      </v-row>
      <v-data-table fixed-header  height="55vh" :headers="headers" :items="desserts" dense class="mt-6">
        <template v-slot:item.actions="{ item }">
          <v-icon small color="primary" class="mr-2" @click="editItem(item)">
            mdi-trash-can-outline
          </v-icon>
        </template>
        <template v-slot:item.actionss="{ item }">
          <v-icon small color="primary" class="mr-2" @click="editItem(item)">
            mdi-link-variant
          </v-icon>
        </template>
      </v-data-table>
    </v-card-text>
    </v-card>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue"
export default {
  name: "Manage Collection Point",
  data: () => {
    return {
      
      headers: [
        { text: "Sno", value: "S_no" },
        { text: "Location ID", value: "Location_ID" },
        { text: "Location Name", value: "Location_Name" },
        { text: "Location Code", value: "Location_Code" },
        { text: "Country", value: "Country" },
        { text: "Delivery Mode", value: "Delivery_Mode" },
        { text: "Delivery Route", value: "Delivery_Route" },
        { text: "Is Enable", value: "Is_Enable" },
        { text: "Map", value: "actionss" },
        { text: "Delete", value: "actions" },
      ],
      desserts: [
        {
          S_no: "1",
          Location_ID: "2685",
          Location_Name: "ABHYUDYA COOPARATIVE BANK LIMITED",
          Location_Code: "IDABH419",
          Country: "INDIA",
          Delivery_Mode: "Bank Transfer",
          Delivery_Route: "",
          Is_Enable: "Y",
          Branch: "Branch",
          
        },
      ],
    };
    
  },
  components: {
    BreadCrumb,
    
  },
};
</script>

<style scoped  lang="scss">
@import "@/global.scss";
</style>
